import { GoldenCanvas } from '@sloyd/3d';
import { Button } from '@sloyd/ui';
import { Checkbox } from './ContentGoldenDetails.components';
import { Actions, Gap, Wrapper } from './ContentGoldenDetails.style';

export type ContentGoldenDetailsProps = {
  id: string;
  golden: IGolden;
  callbacks: {
    onOpenInPlayground: (id: string) => void;
    onPatch: (change: Json) => void;
    onPrev: () => void;
    onNext: () => void;
  };
};

export function ContentGoldenDetails(props: ContentGoldenDetailsProps) {
  const { id, golden, callbacks } = props;
  const { isForSpawn, isInBrowseIdeas, isInExamples, isDeleted } = golden;

  const onPatch = (change: Json) => {
    callbacks.onPatch(change);
  };

  return (
    <Wrapper className='ContentGoldenDetails-wrapper' data-testid='ContentGoldenDetails-wrapper'>
      <GoldenCanvas golden={golden} />
      <Actions>
        <Checkbox
          id={id}
          fieldId='isForSpawn'
          value={isForSpawn}
          label='For spawn [1]'
          hotkey='1'
          onPatch={onPatch}
        />
        <Checkbox
          id={id}
          fieldId='isInBrowseIdeas'
          value={isInBrowseIdeas}
          label='Browse Ideas [2]'
          hotkey='2'
          onPatch={onPatch}
        />
        <Checkbox
          id={id}
          fieldId='isInExamples'
          value={isInExamples}
          label='Examples [3]'
          hotkey='3'
          onPatch={onPatch}
        />
        <Checkbox
          id={id}
          fieldId='isDeleted'
          value={isDeleted}
          label='For deletion [4]'
          hotkey='4'
          onPatch={onPatch}
        />
        <Gap />
        <Button size='xs' variant='outline' onClick={callbacks.onPrev}>
          ← Previous
        </Button>
        <Button size='xs' variant='outline' onClick={callbacks.onNext}>
          Next →
        </Button>
      </Actions>
    </Wrapper>
  );
}

export default ContentGoldenDetails;
